import { useState } from "react";
import "./imagesArticles.css";
import imagenError from "@/assets/img/default/defaultErrorv3.png";

interface Props {
  srcx: string;
  altx: string;
  classNames: string;
  srcDefault: string;
  imagenHome?: boolean;
}

export const ImagesArticles = ({
  srcx,
  altx,
  classNames,
  srcDefault,
  imagenHome = true,
}: Props): JSX.Element => {
  const [isFalback, setIsFalback] = useState(false);
  const [loaded, setLoaded] = useState(false);

  let imagenDefault =
    srcDefault == "" || srcDefault == null ? imagenError : srcDefault;
  // Cambia a la imagen por defecto
  const handleError = () => {
    setIsFalback(!isFalback);
  };

  const handleLoader = () => setLoaded(!loaded);

  const homeClass = imagenHome ? "card-img-padding" : "";

  return (
    <img
      src={
        isFalback
          ? imagenDefault
          : srcx == "" || srcx == null
          ? imagenError
          : srcx
      }
      alt={altx}
      className={`${classNames} ${isFalback ? homeClass : ""}`}
      onLoad={handleLoader}
      onError={handleError}
    />
  );
};
